module.exports = __webpack_public_path__ + "static/media/logo-yazili-w.31d536c2.png";